import React, { Fragment } from "react";
import Accordion from "react-bootstrap/Accordion";
import Card from "react-bootstrap/Card";
import { useAccordionButton } from "react-bootstrap/AccordionButton";
import Breadcrumb from "../../../components/magnolia/breadcrumb/Breadcrumb";
import HtmlHeader from "../../../components/magnolia/htmlHeader/HtmlHeader";

// react-bootstrap 2 dropped Accordion.Toggle; this renders the plain <button> the flone markup
// (and _my-account.scss: .panel-heading > button, h3.panel-title) expects. No .btn-link on
// purpose: Bootstrap 5 underlines it, and the h3 inherits the underline.
const PanelToggle = ({ eventKey, children }) => {
    const toggle = useAccordionButton(eventKey);

    return (
        <button type="button" onClick={toggle}>
            {children}
        </button>
    );
};

// Magnolia twin of flone's pages/other/MyAccount (demo forms, nothing is submitted). It renders
// inside BaseLayout, which already provides the shop's header and footer, so there is no
// LayoutOne here (that gave the page a second, flone-branded header).
const MyAccount = () => {
    return (
        <Fragment>
            <HtmlHeader title="My Account" />
            <Breadcrumb />

            <div className="myaccount-area pb-80 pt-100">
                <div className="container">
                    <div className="row">
                        <div className="ms-auto me-auto col-lg-9">
                            <div className="myaccount-wrapper">
                                <Accordion defaultActiveKey="0">
                                    <Card className="single-my-account mb-20">
                                        <Card.Header className="panel-heading">
                                            <PanelToggle eventKey="0">
                                                <h3 className="panel-title">
                                                    <span>1 .</span> Edit your account information{" "}
                                                </h3>
                                            </PanelToggle>
                                        </Card.Header>
                                        <Accordion.Collapse eventKey="0">
                                            <Card.Body>
                                                <div className="myaccount-info-wrapper">
                                                    <div className="account-info-wrapper">
                                                        <h4>My Account Information</h4>
                                                        <h5>Your Personal Details</h5>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-lg-6 col-md-6">
                                                            <div className="billing-info">
                                                                <label>First Name</label>
                                                                <input type="text" />
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-6 col-md-6">
                                                            <div className="billing-info">
                                                                <label>Last Name</label>
                                                                <input type="text" />
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-12 col-md-12">
                                                            <div className="billing-info">
                                                                <label>Email Address</label>
                                                                <input type="email" />
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-6 col-md-6">
                                                            <div className="billing-info">
                                                                <label>Telephone</label>
                                                                <input type="text" />
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-6 col-md-6">
                                                            <div className="billing-info">
                                                                <label>Fax</label>
                                                                <input type="text" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="billing-back-btn">
                                                        <div className="billing-btn">
                                                            <button type="submit">Continue</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Card.Body>
                                        </Accordion.Collapse>
                                    </Card>
                                    <Card className="single-my-account mb-20">
                                        <Card.Header className="panel-heading">
                                            <PanelToggle eventKey="1">
                                                <h3 className="panel-title">
                                                    <span>2 .</span> Change your password
                                                </h3>
                                            </PanelToggle>
                                        </Card.Header>
                                        <Accordion.Collapse eventKey="1">
                                            <Card.Body>
                                                <div className="myaccount-info-wrapper">
                                                    <div className="account-info-wrapper">
                                                        <h4>Change Password</h4>
                                                        <h5>Your Password</h5>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-lg-12 col-md-12">
                                                            <div className="billing-info">
                                                                <label>Password</label>
                                                                <input type="password" />
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-12 col-md-12">
                                                            <div className="billing-info">
                                                                <label>Password Confirm</label>
                                                                <input type="password" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="billing-back-btn">
                                                        <div className="billing-btn">
                                                            <button type="submit">Continue</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Card.Body>
                                        </Accordion.Collapse>
                                    </Card>
                                    <Card className="single-my-account mb-20">
                                        <Card.Header className="panel-heading">
                                            <PanelToggle eventKey="2">
                                                <h3 className="panel-title">
                                                    <span>3 .</span> Modify your address book entries{" "}
                                                </h3>
                                            </PanelToggle>
                                        </Card.Header>
                                        <Accordion.Collapse eventKey="2">
                                            <Card.Body>
                                                <div className="myaccount-info-wrapper">
                                                    <div className="account-info-wrapper">
                                                        <h4>Address Book Entries</h4>
                                                    </div>
                                                    <div className="entries-wrapper">
                                                        <div className="row">
                                                            <div className="col-lg-6 col-md-6 d-flex align-items-center justify-content-center">
                                                                <div className="entries-info text-center">
                                                                    <p>Farhana hayder (shuvo) </p>
                                                                    <p>hastech </p>
                                                                    <p> Road#1 , Block#c </p>
                                                                    <p> Rampura. </p>
                                                                    <p>Dhaka </p>
                                                                    <p>Bangladesh </p>
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-6 col-md-6 d-flex align-items-center justify-content-center">
                                                                <div className="entries-edit-delete text-center">
                                                                    <button className="edit">Edit</button>
                                                                    <button>Delete</button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="billing-back-btn">
                                                        <div className="billing-btn">
                                                            <button type="submit">Continue</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Card.Body>
                                        </Accordion.Collapse>
                                    </Card>
                                </Accordion>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default MyAccount;